/**
 * Inviting Team Members Tour
 *
 * Guides administrators through team and settings management.
 * Highlights the Astor agent configuration and team settings areas.
 */

import type { TourConfig } from './tour-config.types';

export const teamTour: TourConfig = {
  id: 'inviting-team-members',
  title: 'tours.team.title',
  portal: 'business',
  steps: [
    {
      target: '[data-astor-id="settings-team-management"]',
      content: 'tours.team.steps.teamSettings',
      placement: 'right',
      route: '/team/members',
    },
    {
      target: '[data-astor-id="settings-astor-agents"]',
      content: 'tours.team.steps.configureAstor',
      placement: 'bottom',
      route: '/control-center/astor-agents',
    },
    {
      target: '[data-astor-id="settings-notifications"]',
      content: 'tours.team.steps.notifications',
      placement: 'right',
      route: '/notifications',
    },
  ],
};
